export default {
      id: "ic-soc-intramuros-usage",
      viewBox: "0 0 30 30",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-soc-intramuros-usage",
      toString: function () {
        return this.url;
      }
    }